// src/admin/pages/Dashboard.jsx - Role-aware dashboard dispatcher
import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import AdminDashboard from '../components/Dashboard/AdminDashboard';
import FrontDeskDashboard from '../components/Dashboard/FrontDeskDashboard';
import AccountantDashboard from '../components/Dashboard/AccountantDashboard';
import SalesDashboard from '../components/Dashboard/SalesDashboard';

const Dashboard = () => {
  const { user } = useAuth();

  switch (user?.role) {
    case 'front_desk':
      return <FrontDeskDashboard />;
    case 'accountant':
      return <AccountantDashboard />;
    case 'sales':
      return <SalesDashboard />;
    default:
      // 'admin', 'manager', or unknown → full admin dashboard
      return <AdminDashboard />;
  }
};

export default Dashboard;